import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { BarController, BarElement, CategoryScale, Chart, ChartType, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription, firstValueFrom } from 'rxjs';
import { UploadEditedImageComponent } from 'src/app/community/upload-edited-image/upload-edited-image.component';
import {
  EditedImageBatchResult,
  EditedImageResult,
} from 'src/app/community/upload-edited-image/upload-edited-image.types';
import { ImageModalComponent } from 'src/app/shareModule/component/chat/chatbot/image-modal.component';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';
import { suggestions } from '../../marketplace/view-product-details/view-product.interface';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AddProductComponent } from 'src/app/admin/sub-admin/add-product/add-product.component';
import { tutorialSlides, howSlides, ASK_POST_REWARD_KEY, MOMENTS_REWARD_KEY, POINT_OF_CONTACT_EXTRA_REWARD_KEY, PRODUCTS_POST_REWARD_KEY, RECOMMEND_REWARD_KEY, RECOMMENDATION_IMAGE_EXTRA_REWARD_KEY, REPORTS_REWARD_KEY, REVIEW_REWARD_KEY, REWARD_PER_20_LIKES_DISSCUSS_KEY, REWARD_PER_20_LIKES_RECOMMENDED_PRODOCUT_KEY, REWARD_PER_20_LIKES_XP_KEY, SUGGEST_REWARD_KEY, SUGGESTIONS_REWARD_KEY, POLL_REWARD_KEY } from './site-links.model';
import { RecommendationsFormComponent } from '../recommandations-form/recommandations-form.component';
import { DomSanitizer } from '@angular/platform-browser';
import { PollFormComponent } from 'src/app/poll-form/poll-form.component';
import { SitePromoPopupComponent } from 'src/app/site-promo-popup/site-promo-popup.component';
import { error } from 'console';
import { PopUpService } from 'src/app/popupservice.service';

@Component({
  selector: 'app-site-links',
  templateUrl: './site-links.component.html',
  styleUrl: './site-links.component.scss',
})
export class SiteLinksComponent implements AfterViewInit, OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('mainContainer') mainContainer: ElementRef;

  // private modalRef = null;

  @Output()
  filterProductByFavorite = new EventEmitter();

  public openNoLoginRecommendBox() {
    this.local.confirmYesNo({
      title: '',//'Recommend while not logged in',
      text: 'Do you wish to Recommend without login?',
      icon: 'info'
    })
      .then(
        res => {
          if (res.isConfirmed) {
            this.openRecommendBox(false);
          }
        }
      )

  }
  public readonly CONTRIBUTE_CLICK_COUNT_KEY = 'CONTRIBUTE_CLICK_COUNT';
  public readonly KACHIING_CLICK_COUNT_KEY = 'KACHIING_CLICK_COUNT';
  public readonly SNAP_CLICK_COUNT_KEY = 'SNAP_CLICK_COUNT';
  public readonly RECOMMEND_CLICK_COUNT_KEY = 'RECOMMEND_CLICK_COUNT';
  public readonly MAP_CLICK_COUNT_KEY = 'MAP_CLICK_COUNT';
  public readonly ASK_CLICK_COUNT_KEY = 'ASK_CLICK_COUNT';
  public readonly REWARDS_CLICK_COUNT_KEY = 'REWARDS_CLICK_COUNT';


  public readonly POLL_REWARD_KEY = POLL_REWARD_KEY;



  public POLL_REWARD = 0;
  public POLL_REWARD_LIMIT = 0;




  public registerClick(key) {
    let currentClickCount = 0;
    this.auth.getSiteInfo(key).subscribe({
      next: (data: any) => {
        if (data?.data?.value && Number(data?.data?.value)) {
          currentClickCount = Number(data.data.value);
        }
        currentClickCount++;
        this.auth.setSiteInfo(key, currentClickCount + "").subscribe({ next: console.log, error: console.log })
      },
      error: console.error
    })
  }
  public openRecommendBox(askLogin = true) {


    //console.log("openining recomm box")
    if (askLogin && !this.local.getUser()) {
      this.loginWhy.next({ name: 'add a recommendation', fixZIndex: true });
      return;
    }

    // if (this.sharedService.isOnMobile) {
    //   this.modalRef = this.bottomSheet.open(RecommendationsFormComponent, {
    //     panelClass: 'bottom-sheet-1',
    //     hasBackdrop: true,
    //   });
    //   this.modalRef.instance.activeModal = this.modalRef;
    // } else {
    //   this.modalRef = this.modalService.open(RecommendationsFormComponent);
    // }
    this.modalRef = this.popup.openPopup(RecommendationsFormComponent, { bottomSheetPanelClass: 'bottom-sheet-1', hasBackdrop: true })
  }

  carouselWithNavOptions2: any = {
    spaceBetween: 1,
    slidesPerView: 'auto',
    // loop: true,
    pagination: false,
  };
  isUserLogin: any = 0;
  filterByPopular() {
    this.filterProductByFavorite.emit('');
  }
  public showIsArchived = false;

  public toggleArchive(id, type: 'suggestion' | 'report' | 'recommendation') {
    this.auth.toggleArchiveUserReport({ id, type }).subscribe({
      next: () => {
        this._fetchAllData();
      },
      error: console.error,
    });
  }

  constructor(
    private bottomSheet: MatBottomSheet,
    private router: Router,
    private local: LocalServiceService,
    public sharedService: SharedService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private roleService: RoleService,
    private cdr: ChangeDetectorRef,
    private domSantizer: DomSanitizer,
    private popup: PopUpService
  ) { }

  ngOnDestroy(): void {
    if (this.sharedService.isBrowser()) {
      this._roleSubscription?.unsubscribe();
      this.activeMainSwiper = 0;
    }
  }
  /////////////////////////////////////////////////////////// Code reltated to explanations /////////////////////////////////////
  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth <= 767;
  }
  public get isOnTabOrMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth <= 968;
  }

  @ViewChild('explantionModal')
  public explainationModal: TemplateRef<any>;

  public popupTab: any = [{ title: 'Contribute' }, { title: ' How to' }];

  public getSafeElement(html) {
    return this.domSantizer.bypassSecurityTrustHtml(html);
  }

  @ViewChild('recommSvg')
  public recommSvg: TemplateRef<any>;

  @ViewChild('servicePlusSvg')
  public servicePlusSvg: TemplateRef<any>;

  @ViewChild('earnSvg')
  public earnSvg: TemplateRef<any>;

  @ViewChild('bugSvg')
  public bugSvg: TemplateRef<any>;

  @ViewChild('bulbSvg')
  public bulbSvg: TemplateRef<any>;

  @ViewChild('analyticsSvg')
  public analyticsSvg: TemplateRef<any>;

  @ViewChild('shareSvg')
  public shareSvg: TemplateRef<any>;

  @ViewChild('locationSvg')
  public locationSvg: TemplateRef<any>;

  @ViewChild('rewardSvg')
  public rewardSvg: TemplateRef<any>;

  @ViewChild('reward2Svg')
  public reward2Svg: TemplateRef<any>;

  @ViewChild('adminPanelSvg')
  public adminPanelSvg: TemplateRef<any>;

  @ViewChild('mapSvg')
  public mapSvg: TemplateRef<any>;

  @ViewChild('cameraSvg')
  public cameraSvg: TemplateRef<any>;

  @ViewChild('kachiingSvg')
  public kachiingSvg: TemplateRef<any>;

  public tutorialBtns = [
    // {
    //   goToIndex: 1,
    //   iconClass: 'fa-solid fa-lightbulb',
    //   title: 'Overview',
    // },
    {
      goToIndex: 5,
      // iconClass: 'fa-solid fa-pen',
      title: 'Recommend',
      action: 'recommend',
      templateFunc: () => this.recommSvg,
    },

    // {
    //   goToIndex: 2,f
    //   iconClass: "fa-solid fa-thumbs-up",
    //   title: "Recommend"
    // },
    {
      goToIndex: 3,
      //  iconClass: 'fa-solid  fa-lightbulb',
      title: tutorialSlides[2].title,
      templateFunc: () => this.bulbSvg,
      // iconImage: 'bulb.png',
      action: 'suggest',
    },
    {
      goToIndex: 4,
      //iconClass: 'fa-solid fa-bug',
      title: tutorialSlides[3].title,
      // iconImage: 'bug.webp',
      templateFunc: () => this.bugSvg,
      action: 'report',
    },
    {
      goToIndex: 0,
      // iconClass: 'fa-solid fa-coins',
      templateFunc: () => this.earnSvg,
      title: 'Read to Earn',
    },
    {
      goToIndex: 2,
      //iconClass: 'fa-solid fa-plus',
      title: tutorialSlides[1].title,
      // iconImage: 'plus-ye.png',
      templateFunc: () => this.servicePlusSvg,
      action: 'list',
    },

    // {
    //   goToIndex: 5,
    //   iconClass: "fa-solid fa-gift",
    //   title: "Claim Rewards"
    // }
  ];
  public howBtns = [
    {
      goToIndex: 0,
      // iconImage: 'bulb.png',
      templateFunc: () => this.bulbSvg,
      title: howSlides[0].title,
    },
    {
      goToIndex: 1,
      // iconImage: 'data-analytics.png',
      templateFunc: () => this.analyticsSvg,
      title: howSlides[1].title,
    },
    {
      goToIndex: 2,
      // iconImage: 'recommend.png',
      // iconClass: 'fa-solid fa-thumbs-up',
      templateFunc: () => this.recommSvg,
      title: howSlides[2].title,
    },
    {
      goToIndex: 3,
      // iconClass: 'fa-solid fa-share',
      title: howSlides[3].title,
      templateFunc: () => this.shareSvg,
    },
    {
      goToIndex: 4,
      // iconClass: 'fa-solid fa-location-dot',
      templateFunc: () => this.locationSvg,
      title: howSlides[4].title,
    },
    {
      goToIndex: 5,
      // iconImage: 'reward.png',
      // iconClass:"fa-solid fa-coins",
      templateFunc: () => this.rewardSvg,
      title: howSlides[5].title,
    },
  ];
  public mapQuestionsResponses = []

  public currentBookingResponse = null
  public openMapQuestionResponse(template, response){
    this.currentBookingResponse = response
    this.modalRef = this.modalService.open(template, {size: 'md'})
  }

  private _getMapQuestionsResponses(){
     this.auth.getAllMapQuestionResponse().subscribe({
      next: data =>{
        this.mapQuestionsResponses = []
        const groupedResponses = new Map();

        for(const individualResponse of data.body){
          let {categoryId, userId, typeId, question, response, user, categoryName, typeName} = individualResponse;

          if(!question || !response){
            continue
          }
          if(!user){
            user = `Anon #${userId} on ${categoryName}`
          }

          const KEY = `${(typeId || categoryId)}x${userId}`;
          if(!groupedResponses.has(KEY)){
            groupedResponses.set(KEY, [])
          }

          groupedResponses.get(KEY).push({question,typeId, response, userId, categoryId, user, categoryName, typeName})
        }

        for(const key of groupedResponses.keys()){
           this.mapQuestionsResponses.push(
            groupedResponses.get(key)
           )
          
        }
        
        this.cdr.detectChanges()
      }
     })
  }
  public mainCarouselConfig: any = {
    spaceBetween: 1,
    slidesPerView: 1,
    // loop: true,
    initialSlide: 0,
    autoHeight: true,
    pagination: true,
  };
  private mainExplainerSwiper = null;
  public activeMainSwiper = 0;
  public mainGoTo(index) {
    this.mainExplainerSwiper?.slideTo(index);
    this.activeMainSwiper = index;
  }
  public onMainExplainerSwiper(swiper) {
    this.mainExplainerSwiper = swiper;
  }
  swiperMainSlider(e) {
    this.activeMainSwiper = e.activeIndex;
  }

  private explainerSwiper = null;
  public activeSwiper = 1;
  public tutorialGoTo(index) {
    this.explainerSwiper?.slideTo(index);
    this.activeSwiper = index;
  }
  public onExplainerSwiper(swiper) {
    this.explainerSwiper = swiper;
  }
  swiperSlider(e) {
    this.activeSwiper = e.activeIndex;
  }

  private explainerHowSwiper = null;
  public activeHowSwiper = 0;
  public howGoTo(index) {
    this.explainerHowSwiper?.slideTo(index);
    this.activeHowSwiper = index;
  }
  public onExplainerHowSwiper(swiper) {
    this.explainerHowSwiper = swiper;
  }
  swiperHowSlider(e) {
    this.activeHowSwiper = e.activeIndex;
  }
  public modalRef;
  public showExplantion() {
    this.activeMainSwiper = 0;
    // if (this.isMobile) {
    //   this.modalRef = this.bottomSheet.open(this.explainationModal, {
    //     panelClass: 'bottom-sheet-1',
    //   });
    // } else {
    //   this.modalRef = this.modalService.open(this.explainationModal, {
    //     size: 'md',
    //     windowClass: 'explaination-modal',
    //   });
    // }
    this.modalRef = this.popup.openPopup(this.explainationModal, {
      bottomSheetPanelClass: 'bottom-sheet-1',
      modalSize: 'md',
      modalWindowClass: 'explaination-modal'
    })
  }
  public modalInfoRef;

  public showInfo() {
    if (this.isMobile) {
      this.modalInfoRef = this.bottomSheet.open(SitePromoPopupComponent, {
        panelClass: 'bottom-sheet-1',
      });
    } else {
      this.modalInfoRef = this.modalService.open(SitePromoPopupComponent, {
        size: 'sm',
        centered: true,
        windowClass: 'info-modal',
      });
    }
  }

  /////////////////////////////////////////////////////////// Code related to admin suggestion management will be moved to another file /////////////
  @ViewChild('adminSuggestionModal')
  public adminSuggestionModal: TemplateRef<any>;
  public tutorialSlides = tutorialSlides;
  public howSlides = howSlides;

  public siteInfos = new Map()
  public getAllSiteInfos() {
    this.auth.getAllSiteInfos().subscribe({
      error: console.error,
      next: data => {

        for (const info of data.body) {
          this.siteInfos.set(info.key, info.value)
        }
        for (const key of [this.CONTRIBUTE_CLICK_COUNT_KEY, this.KACHIING_CLICK_COUNT_KEY,
        this.SNAP_CLICK_COUNT_KEY, this.RECOMMEND_CLICK_COUNT_KEY, this.MAP_CLICK_COUNT_KEY, this.ASK_CLICK_COUNT_KEY,
        this.REWARDS_CLICK_COUNT_KEY,]) {
          if (!this.siteInfos.has(key)) {
            this.siteInfos.set(key, 0)
          }

        }
        this.cdr.markForCheck()
      }
    })
  }
  public getAllProps(row: any) {
    const allRatingKeys = ['Rating', 'Count']
      .map((x) => {
        return [`cat${x}`, `ggle${x}`, `fb${x}`];
      })
      .flat();

    const commandedRatingKeys = allRatingKeys.filter(
      (x) => row?.reviewsRatingSuggestion && row?.reviewsRatingSuggestion[x]
    );
    //console.log({ allRatingKeys, commandedRatingKeys });

    const allNewVariantsKeys = [];
    for (let i = 0; i < row.newVariantSuggestions.length; i++) {
      allNewVariantsKeys.push('newVariant' + i);
    }

    const allEmployeesKeys = [];
    for (let i = 0; i < row.newCompanyEmployees.length; i++) {
      allEmployeesKeys.push('newEmployee' + i);
    }

    const commandedDelVarKeys = row.flaggedVariants.map((v) => 'del' + v);

    //console.log({ commandedDelVarKeys });
    //console.log({ row });
    const typeKeys = row.suggestedTypes.map((t) => 'type' + t);

    return [
      ...typeKeys,
      ...commandedDelVarKeys,
      'DESCR',
      'promo',
      ...commandedRatingKeys,
      ...allNewVariantsKeys,
      ...allEmployeesKeys,
      ...['One', 'Two', 'Three', 'Four']
        .map((suff) => 'image' + suff)
        .filter((x) => row[x]),
      ...(row.varSugs?.map((v) => 'var' + v[0]) || []),
    ];
  }
  private _getAllReports(): void {
    this.auth.getAllReports().subscribe((response: ApiResponse) => {
      this.allReports = response?.body || [];
      ////console.log('ALL REPORTS', this.allReports);
    });
  }
  public imgUrl = environment.ImageUrl;

  public allReports = [];
  public adminActiveTab = 'Sheets';
  public rawSuggestions = [];
  public getaAllSuggestions() {
    this.auth.getAllSuggestions().subscribe({
      next: (data) => {
        this.rawSuggestions = data.body;
      },
    });
  }
  public appReview(reviewId, property) {
    this.local
      .confirmYesNo({
        title: 'Are you sure',
        text: 'Are you sure you want to apply change to product',
        icon: 'warning',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.auth.applyReviewChange(reviewId, property).subscribe({
            next: () => {
              this.toastr.success('Change Applied to product');
            },
            error: (err) => {
              console.error(err);
              this.toastr.error(
                'Something went wrong when applying change to product'
              );
            },
          });
        }
      });
  }

  public surveyRecommendations = [];

  private _fetchRecommdations() {
    this.auth
      .getallrecommendations({
        selectAllRegions: true,
        categries: [],
      })
      .subscribe({
        next: (data: any) => {
          this.surveyRecommendations = data.data;
          for (const recomm of this.surveyRecommendations) {
            if (typeof recomm.additionalTags == 'string') {
              try {
                recomm.additionalTags = JSON.parse(recomm.additionalTags);
              } catch (e) {
                console.error(e);
              }
            }
          }
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Error while fetching recommendations');
        },
      });
  }

  public openImage(url) {
    //this.modalService.dismissAll();
    const instance = this.modalService.open(ImageModalComponent, {
      size: 'sm',
      windowClass: 'image-modal',
    });
    instance.componentInstance.imageSrc = environment.ImageUrl + url;
  }
  /////////////////////////////admin settings///////////////////////////

  public readonly RECOMMEND_REWARD_KEY = RECOMMEND_REWARD_KEY;
  public readonly SUGGESTIONS_REWARD_KEY = SUGGESTIONS_REWARD_KEY;
  public readonly REPORTS_REWARD_KEY = REPORTS_REWARD_KEY;
  public readonly PRODUCTS_POST_REWARD_KEY = PRODUCTS_POST_REWARD_KEY;
  public readonly ASK_POST_REWARD_KEY = ASK_POST_REWARD_KEY;
  public readonly REVIEW_REWARD_KEY = REVIEW_REWARD_KEY;
  public readonly SUGGEST_REWARD_KEY = SUGGEST_REWARD_KEY;
  public readonly MOMENTS_REWARD_KEY = MOMENTS_REWARD_KEY;
  public readonly REWARD_PER_20_LIKES_RECOMMENDED_PRODOCUT_KEY = REWARD_PER_20_LIKES_RECOMMENDED_PRODOCUT_KEY;
  public readonly REWARD_PER_20_LIKES_DISSCUSS_KEY = REWARD_PER_20_LIKES_DISSCUSS_KEY;
  public readonly REWARD_PER_20_LIKES_XP_KEY = REWARD_PER_20_LIKES_XP_KEY;
  public readonly POINT_OF_CONTACT_EXTRA_REWARD_KEY = POINT_OF_CONTACT_EXTRA_REWARD_KEY
  public readonly RECOMMENDATION_IMAGE_EXTRA_REWARD_KEY = RECOMMENDATION_IMAGE_EXTRA_REWARD_KEY


  public REWARDS_PER_20 = {
    [this.REWARD_PER_20_LIKES_RECOMMENDED_PRODOCUT_KEY]: 0,
    [this.REWARD_PER_20_LIKES_DISSCUSS_KEY]: 0,
    [this.REWARD_PER_20_LIKES_XP_KEY]: 0,
  };
  public SUGGESTIONS_REWARD = 0;
  public REPORTS_REWARD = 0;
  public PRODUCTS_POST_REWARD = 0;
  public ASK_POST_REWARD = 0;
  public REVIEW_REWARD = 0;
  public SUGGEST_REWARD = 0;
  public RECOMMEND_REWARD = 0;
  public MOMENTS_REWARD = 0;

  public SUGGESTIONS_REWARD_LIMIT = 2;
  public REPORTS_REWARD_LIMIT = 2;
  public PRODUCTS_POST_REWARD_LIMIT = 2;
  public ASK_POST_REWARD_LIMIT = 2;
  public REVIEW_REWARD_LIMIT = 2;
  public SUGGEST_REWARD_LIMIT = 2;
  public MOMENTS_REWARD_LIMIT = 2;
  public RECOMMEND_REWARD_LIMIT = 2;

  public POINT_OF_CONTACT_REWARD = 0;
  public RECOMMEND_EXTRA_IMAGE = 0

  @ViewChild('adminSettingsModal')
  public adminSettingsModal: TemplateRef<any>;
  public adminSettings: any = {
    rewardsSetting: {},
  };
  private _getRewardPts() {
    this.auth.getAssignedPointRewards().subscribe({
      next: (data) => {
        // //console.log({ data });
        this.adminSettings.rewardsSetting = {};
        for (const setting of data.body) {
          this.adminSettings.rewardsSetting[setting.action] = setting.reward;
          this.adminSettings.rewardsSetting['limit' + setting.action] =
            setting.limitPerDay;
        }
        //console.log('adminSettings', this.adminSettings.rewardsSetting)
        for (const prop of [
          this.RECOMMEND_REWARD_KEY,
          this.MOMENTS_REWARD_KEY,
          this.SUGGESTIONS_REWARD_KEY,
          this.REPORTS_REWARD_KEY,
          this.PRODUCTS_POST_REWARD_KEY,
          this.ASK_POST_REWARD_KEY,
          this.REPORTS_REWARD_KEY,
          this.REVIEW_REWARD_KEY,
          this.REWARD_PER_20_LIKES_DISSCUSS_KEY,
          this.REWARD_PER_20_LIKES_RECOMMENDED_PRODOCUT_KEY,
          this.REWARD_PER_20_LIKES_XP_KEY,
          this.POINT_OF_CONTACT_EXTRA_REWARD_KEY,
          this.RECOMMENDATION_IMAGE_EXTRA_REWARD_KEY,
          this.POLL_REWARD_KEY
        ]) {
          if (!this.adminSettings.rewardsSetting[prop]) {
            this.adminSettings.rewardsSetting[prop] = 0;
          }
        }

        this.SUGGESTIONS_REWARD =
          this.adminSettings.rewardsSetting[this.SUGGESTIONS_REWARD_KEY];
        this.REPORTS_REWARD =
          this.adminSettings.rewardsSetting[this.REPORTS_REWARD_KEY];
        this.PRODUCTS_POST_REWARD =
          this.adminSettings.rewardsSetting[this.PRODUCTS_POST_REWARD_KEY];
        this.ASK_POST_REWARD =
          this.adminSettings.rewardsSetting[this.ASK_POST_REWARD_KEY];
        this.REVIEW_REWARD =
          this.adminSettings.rewardsSetting[this.REVIEW_REWARD_KEY];
        this.RECOMMEND_REWARD =
          this.adminSettings.rewardsSetting[this.RECOMMEND_REWARD_KEY];
        this.MOMENTS_REWARD =
          this.adminSettings.rewardsSetting[this.MOMENTS_REWARD_KEY];
        this.POLL_REWARD = this.adminSettings.rewardsSetting[this.POLL_REWARD_KEY];

        this.POINT_OF_CONTACT_REWARD = this.adminSettings.rewardsSetting[POINT_OF_CONTACT_EXTRA_REWARD_KEY]
        this.RECOMMEND_EXTRA_IMAGE = this.adminSettings.rewardsSetting[RECOMMENDATION_IMAGE_EXTRA_REWARD_KEY]

        this.SUGGESTIONS_REWARD_LIMIT =
          this.adminSettings.rewardsSetting[
          'limit' + this.SUGGESTIONS_REWARD_KEY
          ];
        this.REPORTS_REWARD_LIMIT =
          this.adminSettings.rewardsSetting['limit' + this.REPORTS_REWARD_KEY];
        this.PRODUCTS_POST_REWARD_LIMIT =
          this.adminSettings.rewardsSetting[
          'limit' + this.PRODUCTS_POST_REWARD_KEY
          ];
        this.ASK_POST_REWARD_LIMIT =
          this.adminSettings.rewardsSetting['limit' + this.ASK_POST_REWARD_KEY];
        this.REVIEW_REWARD_LIMIT =
          this.adminSettings.rewardsSetting['limit' + this.REVIEW_REWARD_KEY];
        this.SUGGEST_REWARD_LIMIT =
          this.adminSettings.rewardsSetting['limit' + this.MOMENTS_REWARD_KEY];
        this.MOMENTS_REWARD_LIMIT =
          this.adminSettings.rewardsSetting['limit' + this.MOMENTS_REWARD_KEY];
        this.RECOMMEND_REWARD_LIMIT =
          this.adminSettings.rewardsSetting[
          'limit' + this.RECOMMEND_REWARD_KEY
          ];
        this.POLL_REWARD_LIMIT = this.adminSettings.rewardsSetting['limit' + this.POLL_REWARD_KEY] ?? 0

        for (const likeKey of [
          this.REWARD_PER_20_LIKES_DISSCUSS_KEY,
          this.REWARD_PER_20_LIKES_RECOMMENDED_PRODOCUT_KEY,
          this.REWARD_PER_20_LIKES_XP_KEY,
        ]) {
          this.REWARDS_PER_20[likeKey] =
            this.adminSettings.rewardsSetting[likeKey];
        }
        ////console.log(this.REWARDS_PER_20, 'per 20s');
      },
    });
  }
  public openAdminSettings() {
    this.modalService.open(this.adminSettingsModal, { size: 'md' });
  }
  public closeModal() {
    this.activeMainSwiper = 0;
    if (!this.modalRef) {
      this.modalService.dismissAll();
      return;
    }
    if (typeof this.modalRef?.close === 'function') {
      this.modalRef.close();
    } else if (typeof this.modalRef?.dismiss === 'function') {
      this.modalRef.dismiss();
    }
  }
  public saveAdminSettings() {
    ////console.log('rewards: ',   this.adminSettings.rewardsSetting)
    //       public REPORTS_REWARD = 2;
    // public PRODUCTS_POST_REWARD = 2;
    // public ASK_POST_REWARD = 2;
    const actionRewards = [
      {
        action: this.SUGGESTIONS_REWARD_KEY,
        reward: this.SUGGESTIONS_REWARD,
        limitPerDay: this.SUGGESTIONS_REWARD_LIMIT,
      },
      {
        action: this.REPORTS_REWARD_KEY,
        reward: this.REPORTS_REWARD,
        limitPerDay: this.REPORTS_REWARD_LIMIT,
      },
      {
        action: this.PRODUCTS_POST_REWARD_KEY,
        reward: this.PRODUCTS_POST_REWARD,
        limitPerDay: this.PRODUCTS_POST_REWARD_LIMIT,
      },
      {
        action: this.MOMENTS_REWARD_KEY,
        reward: this.MOMENTS_REWARD,
        limitPerDay: this.MOMENTS_REWARD_LIMIT,
      },
      {
        action: this.ASK_POST_REWARD_KEY,
        reward: this.ASK_POST_REWARD,
        limitPerDay: this.ASK_POST_REWARD_LIMIT,
      },
      {
        action: this.REVIEW_REWARD_KEY,
        reward: this.REVIEW_REWARD,
        limitPerDay: this.REVIEW_REWARD_LIMIT,
      },
      {
        action: this.RECOMMEND_REWARD_KEY,
        reward: this.RECOMMEND_REWARD,
        limitPerDay: this.RECOMMEND_REWARD_LIMIT,
      },
      {
        action: this.REWARD_PER_20_LIKES_DISSCUSS_KEY,
        reward: this.REWARDS_PER_20[this.REWARD_PER_20_LIKES_DISSCUSS_KEY],
        limitPerDay: 1,
      },
      {
        action: this.POLL_REWARD_KEY,
        reward: this.POLL_REWARD,
        limitPerDay: this.POLL_REWARD_LIMIT
      },
      {
        action: this.REWARD_PER_20_LIKES_RECOMMENDED_PRODOCUT_KEY,
        reward:
          this.REWARDS_PER_20[
          this.REWARD_PER_20_LIKES_RECOMMENDED_PRODOCUT_KEY
          ],
        limitPerDay: 1,
      },
      {
        action: this.REWARD_PER_20_LIKES_XP_KEY,
        reward: this.REWARDS_PER_20[this.REWARD_PER_20_LIKES_XP_KEY],
        limitPerDay: 1,
      },
      {
        action: this.RECOMMENDATION_IMAGE_EXTRA_REWARD_KEY,
        reward: this.RECOMMEND_EXTRA_IMAGE
      },
      {
        action: this.POINT_OF_CONTACT_EXTRA_REWARD_KEY,
        reward: this.POINT_OF_CONTACT_REWARD,
      }
    ];
    for (const { action, reward, limitPerDay } of actionRewards) {
      this.auth
        .setAssignedPointReward({ action, reward, limitPerDay })
        .subscribe({
          error: console.error,
          next: () => {
            this.toastr.success(`${action} changed`);
          },
        });
    }
  }
  ////////////////////////////////////////////////////////////////////
  public handleClickSiteLink(item: any) {
    if (item.link == '/map' && !this.isUserLogin) {
      this.loginWhy.next({ name: "go to explore map", fixZIndex: true })
      return;

    }
    if (item?.link) {
      this.openLink(item?.link, item?.name);
    } else if (item?.onClick) {
      item.onClick();
    }
  }

  private _suggesgionModalRef: NgbModalRef = null;
  public openAdminSuggestionModal() {
    this._suggesgionModalRef = this.modalService.open(
      this.adminSuggestionModal,
      { size: 'lg', centered: true }
    );

    this._fetchAllData();
  }
  public discardReview(suggestionId) {
    this.local
      .confirmYesNo({
        title: 'Are you sure',
        text: 'Are you sure you want to remove review',
        icon: 'warning',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.auth.removeReview(suggestionId).subscribe({
            next: () => {
              this.fetchUserReviews();
              this.toastr.success('Removed');
            },
            error: (err) => {
              this.toastr.error('Something went wrong while deleting :(');
              console.error(err);
            },
          });
        }
      });
  }

  public suggestions = [];
  public suggestionSearchText = '';
  public currentSuggestionPage = 1;

  public prevPage() {
    if (this.currentSuggestionPage == 1) {
      return;
    }
    this.currentSuggestionPage -= 1;
    this.fetchUserReviews();
  }
  public nextPage() {
    if (this.suggestions.length == 0) {
      return;
    }

    this.currentSuggestionPage += 1;
    this.fetchUserReviews();
  }
  public closeSuggestChangeModal() {
    this._suggesgionModalRef?.close();
  }

  private jsonParseProp(obj: Object, propName: string) {
    try {
      obj[propName] = JSON.parse(obj[propName]);
    } catch (e) {
      console.error(e);
    }
  }

  public fetchUserReviews() {
    this.auth
      .getProductReviews(this.suggestionSearchText, this.currentSuggestionPage)
      .subscribe({
        next: (data) => {
          this.suggestions = data.body;
          this.suggestions.forEach((sug) => {
            try {
              const J = JSON.parse(sug.variationPriceSuggestion);
              sug.varSugs = [];
              for (const K in J) {
                sug.varSugs.push([K, J[K]]);
              }
            } catch (e) {
              console.error(e);
            }
            for (const prop of [
              'newVariantSuggestions',
              'newCompanyEmployees',
              'likedVariants',
              'flaggedVariants',
              'reviewsRatingSuggestion',
              'promoSuggestion',
              'suggestedTypes',
            ]) {
              this.jsonParseProp(sug, prop);
            }

            // this.jsonParseProp(sug, 'newVariantSuggestions')
            // this.jsonParseProp(sug, 'newCompanyEmployees')
            // this.jsonParseProp(sug, 'likedVariants')
            // this.jsonParseProp(sug, '')
            // try{
            //   const J = JSON.parse(sug.newVariantSuggestions)
            //   sug.newVariantSuggestions = J;
            //   //console.log('suggestions=',sug.newVariantSuggestions)

            // }catch(e){
            //   console.error(e)
            // }

            // try{
            //   const J = JSON.parse(sug.newCompanyEmployees)
            //   sug.newCompanyEmployees = J;
            //   //console.log('employees=',sug.newCompanyEmployees)

            // }catch(e){
            //   console.error(e)
            // }

            // try {
            //   const J = JSON.parse(sug.likedVariants);
            //   sug.likedVariants = J

            // } catch (e) {
            //   console.error(e)
            // }

            // try {
            //   const J = JSON.parse(sug.flaggedVariants);
            //   sug.flaggedVariants = J

            // } catch (e) {
            //   console.error(e)
            // }

            // try {
            //   const J = JSON.parse(sug.reviewsRatingSuggestion)
            //   sug.reviewsRatingSuggestion = J
            //   //console.log({ J })
            // } catch (e) {
            //   console.error(e)
            // }
          });
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Something went wrong please try again latter');
        },
      });
  }
  public suggestionMap = suggestions;

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private referralCode = '';
  private _roleSubscription: Subscription = null;
  public isAdmin = false;
  @ViewChild('AddShop') addProductComponent: AddProductComponent;
  public promoteRecomm(recomm, isPromo = false) {
    if (isPromo) {
      this.local
        .confirmYesNo({
          text: 'Are you sure you want to change this to a promo',
          title: 'Upgrade To Promo',
          icon: 'info',
        })
        .then((res) => {
          if (res.isConfirmed) {
            this.auth.makeRecommendationAPromo(recomm.id).subscribe({
              next: () => {
                this.toastr.success('Upgraded');
              },
              error: (err) => {
                console.error(err);
                this.toastr.error('Error something went wrong');
              },
            });
          }
        });
    } else {
      this.addProductComponent.promoteRecommendation(recomm);
      (this.addProductComponent.modalRef as NgbModalRef).closed.subscribe(() => {
        this.toggleArchive(recomm.id, 'recommendation');

      })
    }
  }
  public deleteRecomm(recomm) {
    this.local
      .confirmYesNo({
        text: 'Are you sure you want to remove this recommendation',
        title: 'Remove Recommendation',
        icon: 'warning',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.auth.deleteRecommendation(recomm.id).subscribe({
            next: () => {
              this.toastr.success('Recommendation removed');
              this._fetchRecommdations();
            },
            error: (err) => {
              console.error(err);
              this.toastr.error(
                'Something went wrong while delete recommendation'
              );
            },
          });
        }
      });
  }
  private _fetchAllData() {
    if (this.isAdmin) {
      this.fetchUserReviews(); //reviews TODO RENAME TO REMVOE CONFUSION
      this._getAllReports();
      this.getAllSiteInfos()

      this._fetchRecommdations();
      this.getaAllSuggestions(); //normal suggestions
      this.getRewardListForAllUsers();
      this.getClaimListForAllUsers();
      this._getMapQuestionsResponses()
    }
    this._getRewardPts();
    this._fetchPollData();
  }
  public deletePoll(poll) {
    this.auth.poll_delete(poll.id).subscribe({
      error: console.error,
      next: () => {
        this._fetchPollData();
      },
    });
  }

  public openEndedPollAnswers = []
  public seeAnswersToPoll(poll) {
    // this.auth.getOpenEndedAnswersForPoll(poll.id).subscribe({
    //   next: data=>{
    //     this.openEndedPollAnswers = data.body.filter(poll => poll.answer);
    //     this.currentIndustryStandard = poll.industryStandard;
    //     this.currentCounts = []
    //     let yesCount = 0;
    //     let noCount = 0;
    //     let otherCount =0;

    //     const comparableAnswers =  data.body.filter(poll => poll.comparableAns);
    //     for(const ans of comparableAnswers){
    //       if(ans?.comparableAns?.toLowerCase() == 'yes'){
    //         yesCount++;
    //       }
    //       else if(ans?.comparableAns?.toLowerCase() == 'no'){
    //         noCount++;
    //       }
    //       else{
    //         otherCount ++;
    //       }
    //       this.currentCounts = [yesCount, noCount, otherCount]
    //     }


    //     this.comparableAnswers = this.currentCounts.some(c => c) && !!this.currentIndustryStandard;
    //     console.log(this.currentCounts, this.currentIndustryStandard, this.comparableAnswers)
    //     this._setupChart()

    //     this.cdr.detectChanges()

    //   },
    //   error: console.error
    // })
  }

  private leftTexts = ['Left A', 'Left B', 'Left C'];
  private rightTexts = ['Right 1', 'Right 2'];
  private middleText = '';

  private _usingChart = false
  public comparableAnswers = false;
  private currentIndustryStandard = '';
  private currentCounts = [10, 12, 25]
  private _setupChart() {
    // if(this._usingChart){
    //   return;
    // }
    // this._usingChart = true;
    const ctx = this.myChart.nativeElement
    // const ctx = document.getElementById('myChart') as HTMLCanvasElement;

    // ✅ Register required pieces
    Chart.register(
      CategoryScale,
      LinearScale,
      BarController,
      BarElement,
      Title,
      Tooltip,
      Legend
    );



    const customTextPlugin = {
      id: 'customText',
      afterDraw: (chart: any) => {
        const { ctx, chartArea } = chart;
        const { top, bottom, left, right, width } = chartArea;
        const midY = (top + bottom) / 2;
        const midX = left + width / 2;

        ctx.save();
        ctx.font = '14px Arial';
        ctx.fillStyle = 'black';
        ctx.textBaseline = 'middle';

        // Draw left texts (stacked)
        this.leftTexts.forEach((txt, i) => {
          const y = top + 20 + i * 20; // 20px spacing
          ctx.textAlign = 'left';
          ctx.fillText(txt, left - 80, y);
        });

        // Draw middle text
        ctx.textAlign = 'center';
        ctx.fillText(this.middleText, midX, midY);

        // Draw right texts (stacked)
        this.rightTexts.forEach((txt, i) => {
          const y = top + 20 + i * 20;
          ctx.textAlign = 'right';
          ctx.fillText(txt, right + 80, y);
        });

        ctx.restore();
      }
    };
    Chart.register(customTextPlugin);


    new Chart(ctx, {
      type: 'bar' as ChartType,
      data: {
        labels: ['Yes', this.currentIndustryStandard, 'No'],
        datasets: [
          {
            label: 'Sample',
            data: this.currentCounts,
            backgroundColor: 'rgba(75, 192, 192, 0.5)'
          }
        ]
      },
      options: {
        responsive: true
      }
    });
  }

  @ViewChild('myChart')
  public myChart: ElementRef;

  ngAfterViewChecked(): void {
    // if(this.sharedService.isBrowser() && this.myChart?.nativeElement){
    //   //this._setupChart()
    //   this.isU
    // }else{
    //   this._usingChart = false;
    // }
  }


  private _fetchPollData() {
    this.auth
      .poll_fetch({ isAll: false, productId: null, fetchCategoryOnly: true })
      .subscribe({
        next: (data: any) => {
          //console.log({ data })
          this.categoryPolls = data.body.data;

          //console.log('polls data', this.categoryPolls)
          this.cdr.markForCheck();
        },
        error: console.error,
      });
  }
  public changeRewardKeyName(key: string) {
    return key.toLocaleLowerCase().split('_').join(' ').replace('key', '');
  }


  public rewardEvidence = null;
  @ViewChild('evidence') evidenceModal: TemplateRef<any>
  public openRewardEvidence(rewardEvidence) {
    if (!rewardEvidence || (!rewardEvidence?.image && !rewardEvidence?.text)) {
      return;
    }
    this.rewardEvidence = rewardEvidence
    this.modalRef = this.modalService.open(this.evidenceModal, { size: 'md' })

  }


  public rewardsGivenToUsers = [];
  private getRewardListForAllUsers() {
    this.auth.getRewardListForAllUsers().subscribe({
      next: (data) => {
        this.rewardsGivenToUsers = data.body;
        for (const reward of this.rewardsGivenToUsers) {
          try {
            reward.payload = JSON.parse(reward.payload ?? '{}')

          } catch (e) {
            console.error(e)
          }

        }
        this.cdr.markForCheck();
      },
      error: console.error,
    });
  }
  public handleRewardAction(claim) {
    let obs;
    if (claim.status == 'NOT_SENT') {
      obs = this.auth.setClaimStatus(claim?.id, 'SENT');
    } else {
      obs = this.auth.setClaimStatus(claim?.id, 'NOT_SENT');
    }
    obs.subscribe({
      next: () => {
        this.getClaimListForAllUsers();
        this.toastr.success('changed');
      },
      error: (err) => {
        this.toastr.error('Something went wrong');
        console.error(err);
      },
    });
  }
  viewReportDetail(report: any) {
    if (report.category == 'product') {
      window.open(
        `${window.location.origin}/product/${report.memberProductSlug}`,
        '_blank'
      );
    }
    // else if (report.category == "biz_product") {
    //   window.open(`${window.location.origin}/biz/${report.product_id}`, "_blank");
    // }
  }
  public allUserClaims = [];
  public getClaimListForAllUsers() {
    this.auth.getAllClaimableRewardClaims().subscribe({
      next: (data) => {
        this.allUserClaims = data.body;
        this.cdr.markForCheck();
      },
      error: console.error,
    });
  }
  public showButton: boolean = false;
  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {
      this._fetchCats();
      this.activeMainSwiper = 0;
      this._fetchAllData();
      this.getSubRegionList();
      

      this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
        this.isAdmin = this.roleService?.roles?.userType.includes('ADMIN');
        this.cdr.markForCheck();
      });

      this.local.getUserDetailsObserver().subscribe((user) => {
        if (!this.sharedService.isBrowser()) {
          return;
        }
        this.referralCode = this.local.getUser()?.referralCode;
        if (user?.id) {
          this.isUserLogin = 1;
          this.links = [...this.links];
          this.cdr.markForCheck();
        } else {
          this.isUserLogin = 0;
        }
      });
      this.showButton = true;
      this.cdr.markForCheck();
    }
  }
  ngAfterViewInit(): void {
    // if(window.innerWidth <= 767){
    //   const scrollAmount = (document.documentElement.scrollWidth * 37.5) / 100;
    //   this.mainContainer?.nativeElement?.scroll(scrollAmount, 0)
    // }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  public subregionImageUploadId = 'subregion-upload-image';
  public subregionImageUploadIdCamera = 'subregion-upload-image-camera';
  public selectedRegionImageToUpload: File | null = null;
  public selectedRegionImageToUploadBuffer = null;

  public subregionImageUploadChanged(event) {
    const { target } = event;
    const file = target.files[0];

    this.selectedRegionImageToUpload = file;

    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.selectedRegionImageToUploadBuffer = fileReader.result;
    };
    fileReader.readAsDataURL(this.selectedRegionImageToUpload);
  }
  private getActiveSubregionId() {
    let subRegionId = this.local.getUser()?.region;

    return subRegionId;
  }
  public subregionImageUploadCurrentCaption = '';
  public categoryPolls = [];
  public submitSubregionFileUpload() {
    if (!this.selectedRegionImageToUpload) {
      this.toastr.info('Please select an image first');
      return;
    }
    const uploadData = new FormData();
    uploadData.append('subregionId', this.getActiveSubregionId());
    uploadData.append('image', this.selectedRegionImageToUpload);
    uploadData.append('caption', this.subregionImageUploadCurrentCaption);

    this.auth.uploadSubregionImage(uploadData).subscribe({
      next: () => {
        this.toastr.success('Uploaded!');
        this.selectedRegionImageToUpload = null;
        this.selectedRegionImageToUploadBuffer = null;
        this.subregionImageUploadCurrentCaption = '';
        this.modalService.dismissAll();
        this._getSubRegionImages();
      },

      error: (err) => {
        this.toastr.error('Error something went wrong!');
        console.error(err);
        console.log;
      },
    });
  }
  //private chickenRiceSubCat = null;
  public cats = [];
  private _fetchCats() {
    this.commonService.categoryList.subscribe((response: any) => {
      this.cats = structuredClone(response);
      ////console.log('cats are awesome', this.cats)

      // for (const cat of this.cats) {
      //   for (const subCat of cat.subCategory) {
      //     if (
      //       subCat?.categoryName?.toLocaleLowerCase()?.trim() == 'chicken rice'
      //     ) {
      //       this.chickenRiceSubCat = subCat;
      //       break;
      //     }
      //   }
      // }

      //this.cdr.markForCheck();
    });
  }
  public openPollNow() {
    this.sharedService.openNewUserSurveySubject.next(true);
  }

  public openPollModal() {
    this.modalRef = this.modalService.open(PollFormComponent, { size: 'sm' });
    this.modalRef.componentInstance.isCategoryBased = true;
    // this.chickenRiceSubCat.categorieChildId;
    this.modalRef.hidden.subscribe(() => {
      this._fetchPollData();
    });
  }

  public currentCropInformationToBeSaved = null;

  public openUploadSubregionImageModal() {
    const modalRef = this.modalService.open(UploadEditedImageComponent, {
      size: 'sm',
      centered: true,
    });
    let topText = '';
    const user = this.local.getUser();

    if (user) {
      topText = this.commonService.getSubregionName(user.region);
    }

    modalRef.componentInstance.topText = topText;
    modalRef.result.then(async (res: EditedImageBatchResult) => {
      const images = res?.images ?? [];
      if (!images.length) {
        return;
      }

      let success = 0;
      let failed = 0;

      for (const image of images) {
        const uploadData = new FormData();
        uploadData.append('subregionId', this.getActiveSubregionId());
        uploadData.append('image', image.imageData);
        uploadData.append('caption', image.caption ?? '');
        if (image.cropInformation) {
          uploadData.append(
            'cropInformation',
            typeof image.cropInformation === 'string'
              ? image.cropInformation
              : JSON.stringify(image.cropInformation),
          );
        }

        try {
          await firstValueFrom(this.auth.uploadSubregionImage(uploadData));
          success++;
        } catch (error) {
          failed++;
          console.error(error);
        }
      }

      if (success) {
        this.toastr.success(
          `${success} image${success > 1 ? 's' : ''} uploaded successfully`,
        );
        this.modalService.dismissAll();
        this._getSubRegionImages();
      }
      if (failed) {
        this.toastr.error(
          `${failed} image${failed > 1 ? 's' : ''} failed to upload`,
        );
      }
    });
  }
  public subregionUploadedImage = [];
  public showImagePopup(url, text = '') {
    const instance = this.modalService.open(ImageModalComponent, {
      size: 'sm',
      windowClass: 'image-modal',
    });
    instance.componentInstance.imageSrc = environment.ImageUrl + url;
    instance.componentInstance.descr = text;
  }
  public imageUrl = environment.ImageUrl;

  private _getSubRegionImages() {
    this.auth
      .getSubRegionUploadedImages(this.getActiveSubregionId())
      .subscribe({
        next: (data) => {
          this.subregionUploadedImage = data.body;
        },
        error: (err) => {
          console.error(err);
        },
      });
  }


  public toggleUploadRxn(uploadedImage, type) {
    this.auth.toggleUploadReaction(uploadedImage.id, type).subscribe({
      next: () => {
        this._getSubRegionImages();
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Error something went wrong while reacting');
      },
    });
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  handleSuggestion() {
    this.local.alertSuggestion('Suggest').then((result) => {
      if (result.isConfirmed && result.value) {
        const report = result.value;
        this.auth
          .submitSuggestionMessage({
            message: report.reportDetails,
            //type: null,
            // product_id: id,
          })
          .subscribe(
            (response: any) => {
              this.toastr.success('Suggested successfully');
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
      }
    });
  }

  public clickLogin() {
    this.modalService.dismissAll();
    this.commonService.clickButton('loginBtn');
  }
  public doesRowHaveInfo(row) {
    return (
      row?.descriptionChanges ||
      ['One', 'Two', 'Three', 'Four'].some(
        (suff) => row && row['image' + suff]
      ) ||
      row?.varSugs?.length ||
      row?.likedVariants?.length ||
      row?.flaggedVariants?.length ||
      row?.newVariantSuggestions?.length ||
      row?.newCompanyEmployees?.length ||
      row?.reviewsRatingSuggestion?.ggleRating ||
      row?.reviewsRatingSuggestion?.ggleCount ||
      row?.reviewsRatingSuggestion?.fbRating ||
      row?.reviewsRatingSuggestion?.fbCount ||
      row?.reviewsRatingSuggestion?.carRating ||
      row?.reviewsRatingSuggestion?.carCount ||
      ['imageFile', 'serviceComment', 'serviceDescription', 'iconText'].some(
        (prop) => row?.promoSuggestion[prop]
      ) ||
      (row?.suggestedTypes &&
        row?.suggestedTypes != '[]' &&
        row?.suggestedTypes?.length)
    );
  }
  public removeHowTo(row) {
    this.auth.removeHowTo(row.approvedHowToId)
      .subscribe({
        next: () => {
          this.toastr.success("Changed")
          this._fetchAllData()
        },
        error: (err: any) => {
          console.error(err);
          this.toastr.error(err.error.message)
        }
      })
  }
  public approveHowTo(row) {
    const howTo = {
      howMuch: row.howMuch,
      howOrder: row.howOrder,
      pointOfContact: row.pointOfContact
    };
    this.auth.approveProductHowTo(row.memberProductId, row.howMuch, row.howOrder, row.pointOfContact, row.id).subscribe({
      next: () => {
        this.toastr.success("Changed")
        this._fetchAllData()
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error(err.error.message)
      }
    })
  }
  public rowHasSurvey(row) {
    return (
      this.suggestionMap.some((f) => row[f.apiName]) ||
      row.wouldRecommend ||
      row.whyRecommend ||
      row.howMuch ||
      row.howOrder ||
      row.pointOfContact
    );
  }
  private subRegionList = [];

  private getSubRegionList(): void {
    this.auth.getMemberShopSubRegion().subscribe((response) => {
      this.subRegionList = response?.body || [];
    });
  }

  public editRecomm(recomm) {
    if (!this.local.getUser()) {
      this.commonService.clickButton('loginBtn');
      return;
    }
    try {
      //console.log('editing', recomm)

      const s = this.modalService.open(RecommendationsFormComponent);
      const originalSubregion = this.subRegionList.find(
        (subRegion) => subRegion.name == recomm.regionName
      );
      s.componentInstance.editRecommId = recomm.id;
      s.componentInstance.name = recomm.nameOfServiceProvider;
      s.componentInstance.contactDetails = recomm.phone;
      s.componentInstance.company = recomm.company;
      s.componentInstance.expiry = recomm.promoExpiry;

      s.componentInstance.isEdit = true;
      s.componentInstance.selectedSubRegion = originalSubregion;
      //console.log(
      // originalSubregion,
      // 'guven',
      // this.subRegionList,
      // recomm.regionName
      // );
      s.componentInstance.banner_image_url =
        this.imageUrl + recomm.imageLocation;
      try {
        s.componentInstance.additionalTags = JSON.stringify(
          recomm.additionalTags
        );

      } catch (e) {
        console.error(e)
      }

      s.componentInstance.catName = recomm.categoryName;
      s.componentInstance.pointOfContact = recomm.pointOfContact;
      //s.componentInstance.selectedPromoExpiry = recomm.promoExpiry;
      s.componentInstance.additionalDescr = recomm.additionalDescr;
      if (recomm.additionalTags) {
        if (typeof recomm.additionalTags == 'string') {
          recomm.additionalTags = JSON.parse(recomm.additionalTags);
        }
        //console.log('additional tags', recomm.additionalTags)
        s.componentInstance.recommType = [
          'Food',
          'Professional Services',
          'Freelance',
          'Promotions',
        ].indexOf(recomm.additionalTags[0]);
      }
      this.cdr.detectChanges();
    } catch (e) {
      console.error(e);
    }
  }

  @Output()
  public loginWhy = new EventEmitter();

  public openListService() {
    this.addProductComponent.isRecommendedProduct = true;
    this.addProductComponent.memberShopProductType = 'promote';
    this.addProductComponent.newProduct({closeAll: false});
  }

  public openLink(link, name) {
    if (link?.startsWith('http')) {
      window.location.href = link;
      return;
    }
    const isUserLoggedIn = this.local.getUser();
    if (
      !isUserLoggedIn &&
      [
        'Nearby',
        'Favorites',
        'Report Bug',
        'Share Moment',
        'Services',
        'Suggest Improvement',
        'Map Explore',
        'List Service',
        //   'Rewards'
      ].includes(name)
    ) {
      this.loginWhy.emit(name);
      return;
    }
    if (name == 'Contribute') {
      this.showExplantion();
      return;
    }
    if (name == 'Share Moment') {
      this.openUploadSubregionImageModal();
      return;
    }
    if (name == 'Suggest Improvement') {
      this.handleSuggestion();
      return;
    }
    if (name == 'List Service') {
      this.openListService();
      return;
    }

    if (name == 'Favourites') {
      link = link + this.local?.getUser()?.referralCode;
    }
    this.router.navigateByUrl(link);
  }

  public openReportForm() {
    this.local.alertReport().then((result) => {
      if (result.isConfirmed && result.value) {
        const report = result.value;

        const data = new FormData();
        data.append('message', report.reportDetails);
        data.append('type', report.reportType);
        data.append('category', 'member');
        data.append('image', report.file);
        this.auth.submitReportMessage(data).subscribe(
          () => {
            this.toastr.success('Reported successfully');
          },
          (e) => {
            this.toastr.error(e.error.message);
          }
        );
      }
    });
  }
  private _fixModalZIndexes() {
    const elems: Element[] = [];

    const ngbModalElems = document.getElementsByClassName('modal');
    if (ngbModalElems.length) {
      //console.log(
      //   'found',
      //   ngbModalElems.length,
      //   'elments with modal class name'
      // );
      elems.push(ngbModalElems[0]);
    } else {
      //console.log('no bootstrap element found');
    }

    const swalElems = document.getElementsByClassName('swal2-container');
    if (swalElems.length) {
      //console.log('found', swalElems.length, 'elments with swal class name');
      elems.push(swalElems[0]);
    } else {
      //console.log('no swal element found');
    }

    for (const elem of elems) {
      (elem as any).style.zIndex = 2000;
    }
  }
  public fixZIndexSafe() {
    try {
      this._fixModalZIndexes();
      const subs = this.local.swalShowingSubject.subscribe((isOpen) => {
        if (isOpen) {
          this._fixModalZIndexes();
          subs.unsubscribe();
        }
      });
    } catch (e) {
      console.error(e);
    }
  }
  public performExplainerAction(action) {
    switch (action) {
      case 'recommend': {
        //console.log("calling recommend")
        this.openRecommendBox();
        break;
      }
      case 'report': {
        if (!this.isUserLogin) {
          this.loginWhy.next({ name: "report an issue", fixZIndex: true })
          return;
        }
        this.openReportForm();
        this.fixZIndexSafe();
        break;
      }
      case 'suggest': {
        if (!this.isUserLogin) {
          this.loginWhy.next({ name: "add a suggestion", fixZIndex: true })
          return;
        }
        this.handleSuggestion();
        this.fixZIndexSafe();
        break;
      }
      case 'list': {
        if (!this.isUserLogin) {
          this.loginWhy.next({ name: "list a service", fixZIndex: true })
          return;
        }
        this.openListService();
        if (this.isMobile) {
          this.fixZIndexSafe();
        }

        break;
      }
      default: {
        console.error('Error invalid action', action);
      }
    }
  }
  public links: any = [
    {
      name: 'Admin Panel',
      // image: 'gear.png',
      templateFunc: () => this.adminPanelSvg,

      onClick: () => {
        this.openAdminSuggestionModal();
      },
    },
    // {
    //     name: 'Suggestions',
    //     image: 'attach-file.png'
    // },
    {
      name: 'Contribute',
      image: 'w-removebg.png',
      onClick: () => {
        this.showExplantion();
      },
    },
    {
      name: 'Kachiing?',
      // image: 'what.png',
      link: '/what-is-kachiing',
      templateFunc: () => this.kachiingSvg,
    },

    {
      name: 'Snap & List',
      // image: 'snap-list.webp',
      templateFunc: () => this.cameraSvg,
      onClick: () => {
        this.openRecommendBox();
      },
    },

    // {
    //   name: 'Report Bug',f
    //   image: 'bug.webp',
    //   link: null,
    // },
    {
      name: 'Rewards',
      // image: 'reward-2.png',
      templateFunc: () => this.reward2Svg,
      link: '/rewards',
    },
    // {
    //   name: 'Suggest Improvement',
    //   image: 'bulb.png',
    //   link: null,
    // },

    {
      name: 'Map Explore',
      // image: 'map-page.webp',
      templateFunc: () => this.mapSvg,
      link: '/map',
    },
    {
      name: 'Ask',
      image: 'telegram.png',
      link: 'https://t.me/+EdZ7muBSDJ1lMWY1',
    },
    // {
    //   name: 'Services',
    //   image: 'search_2.png',
    //   link: '/me/nearby',
    // },
    // {
    //   name: 'Giveaway',
    //   image: 'gift_2.png',
    //   link: '/giveaway',
    //   // glow: true,
    // },
    // {
    //   name: 'List Service',
    //   image: 'plus-ye.png',
    //   link: null
    // },
    // {
    //   name: 'Share Moment',
    //   image: 'near-me-upload.webp',
    //   link: '-',
    // },

    // {
    //   name: 'Join us',
    //   image: 'join.png',
    //   link: '/biz/join',
    // },
    // {
    //   name: 'Favourites',
    //   image: 'love.png',
    //   link: '/profile/',
    // },
    // {
    //   name: 'News',
    //   image: 'news.png',
    //   link: '/news',
    // },
    // {
    //   name: 'FAQ',
    //   image: 'faq.png',
    //   link: '/faq',
    // },
  ];
}
